import React from "react";
import DeveloperPage from "../../components/developers";

const DeveloperAll = () => {
  return <DeveloperPage />;
};

export default DeveloperAll;
